<template>
    <div class="cl-artist-card-cont" @click="onClickArtist(collab.id)">
        <img class="cl-artist-card-img" :src="collab.coverPhoto" alt="profile"/>
        <div class="cl-artist-card-text">
            <div>
                <div class="cl-artist-card-title">{{ collab.artistName }}</div>
                <div class="cl-artist-loop-link">
                    <div class="cl-artist-pack-list">{{ `${Object.keys(collab.loops).length} loop pack${Object.keys(collab.loops).length === 1 ? '' : 's'}`}}</div>
                    <img src="../assets/image/path.png" alt="link" style="margin-left: 7px;"/>
                </div>
            </div>
            <div>{{ loopTitleString }}</div>
            <div class="cl-artist-sessions">Artist Sessions</div>
        </div>
    </div>
</template>
<script>
    export default {
      name: 'ArtistCard',
      props: {
        onSelectArtist: {
          type: Function
        },
        collab: {
          type: Object,
          required: true
        }
      },
      computed: {
        loopTitleString: function() {
          const loopTitles = Object.keys(this.collab.loops).map((loop) => {
            return this.collab.loops[loop].title;
          });
          return loopTitles.join(', ');
        }
      },
      methods: {
        onClickArtist(collabId) {
          this.onSelectArtist(collabId);
        }
      }
    }
</script>
<style lang="scss">
@import '~vuetify/src/styles/settings/_variables';
    .cl-artist-card-cont {
        display: flex;
        width: 380px;
        height: 190px;
        background-color: #2b2b2b;
        border-radius: 6px;
        margin: 10px;
        cursor: pointer;
        box-sizing: border-box;

        &:hover {
            filter: brightness(110%);
        }
    }

    .cl-artist-card-img {
        width: 190px;
        height: 190px;
        border-radius: 6px;
        object-fit: cover;
    }

    .cl-artist-loop-link {
        display: flex;
        align-items: center;
    }

    .cl-artist-card-text {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 15px;
        font-size: 13px;
        font-family: Lato-Regular, sans-serif;
    }

    .cl-artist-card-title {
        font-size: 15px;
        font-weight: bold;
    }

    .cl-artist-sessions {
        font-family: Lato-Regular, sans-serif;
        opacity: 0.5;
    }

    @media only screen and (min-width: 768px) and (max-width: 835px) {
        .cl-artist-card-cont {
            width: 330px;
            height: 150px;
        }

        .cl-artist-card-img {
            width: 150px;
            height: 150px;
        }

        .cl-artist-card-text {
            font-size: 12px;
        }

        .cl-artist-card-title {
            font-size: 14px;
        }
    }

    @media only screen and (max-width: 767px) {
        .cl-artist-card-cont {
            width: 260px;
            height: 130px;
        }

        .cl-artist-card-img {
            width: 130px;
            height: 130px;
        }

        .cl-artist-card-text {
            font-size: 11px;
            padding: 10px 15px;
        }

        .cl-artist-card-title {
            font-size: 13px;
        }

        .cl-artist-pack-list {
            font-size: 11px;
            line-height: 5px;
        }
    }

    @media #{map-get($display-breakpoints, 'xs-only')} {
      .cl-artist-card-cont {
        width: 294px;
        height: 147px;
        margin: 6px;
      }

      .cl-artist-card-img {
        width: 147px;
        height: 147px;
      }
    }
</style>